<template>
	<div class="layout-footer">
		<div class="layout-footer__left">主办：重庆市大渡口区发展和改革委员会</div>
		<div class="layout-footer__center">承办：重庆建桥实业发展有限公司</div>
		<div class="layout-footer__right">渝ICP备16007946号</div>
	</div>
</template>
<script>
	export default {
	}
</script>
<style>
	.layout-footer {
	    width: 1300px;
	    padding: 20px;
	    margin: auto;
	    color: #b1b1b1;
	    font-size: 14px;
	    font-weight: bold;
	    display: flex;
	    justify-content: center;
	}
	.layout-footer__left{margin-right: 30px;}
	.layout-footer__center{margin-right: 30px;}
</style>